import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const AcessoNegado = () => {
  const navigate = useNavigate();
  const isCliente = localStorage.getItem('isCliente') === 'true';

  const handleVoltar = () => {
    if (isCliente) {
      const id_bpo = localStorage.getItem('id_bpo');
      navigate(`/dashboard-cliente/${id_bpo}/`);
    } else {
      navigate('/home');
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center p-5">
        <div className="mb-4">
          <i className="fas fa-lock fa-5x text-danger"></i>
        </div>
        
        <h1 className="display-4 text-danger mb-3">Acesso Negado</h1>
        
        <p className="lead text-muted mb-4">
          Você não tem permissão para acessar esta página.
        </p>
        
        <div className="alert alert-warning d-inline-block mb-4">
          <i className="fas fa-exclamation-triangle me-2"></i>
          {isCliente ? (
            <span>Esta área é restrita para funcionários da empresa.</span>
          ) : (
            <span>Esta área é restrita para clientes específicos.</span>
          )}
        </div>
        
        <div className="d-flex justify-content-center gap-3">
          <button onClick={handleVoltar} className="btn btn-primary btn-lg">
            <i className="fas fa-arrow-left me-2"></i>
            Voltar para {isCliente ? 'Área do Cliente' : 'Home'}
          </button>
          
          <button onClick={handleLogout} className="btn btn-outline-secondary btn-lg">
            <i className="fas fa-sign-out-alt me-2"></i>
            Sair
          </button>
        </div>
        
        <div className="mt-5">
          <p className="text-muted small">
            Se você acredita que deveria ter acesso a esta página, entre em contato com o administrador.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AcessoNegado;